import { router } from "./Routing";
import { RouterProvider } from "react-router-dom";
function App() {
  return <RouterProvider router={router} />;
}

export default App;

/* let element = useRoutes([
    {
      path: "/text",
      element: <SignIn />,
    },
  ]);

  {
    element;
  }
 */
